import { Subject } from 'rxjs';
import apiResponse from '../../../../services/apiResponse';
import IndexRepository from '../Repositories/IndexRepository';

class IndexBloc {
  repository = new IndexRepository();
  dataChannel = new Subject();

  //FILTER
  workUnitChannel = new Subject();

  //DATA PEGAWAI
  employeesChannel = new Subject();
  agesChannel = new Subject();
  employeeStatusChannel = new Subject();
  jabatanChannel = new Subject();
  positionGradeChannel = new Subject();
  pensiunListChannel = new Subject();
  rankChannel = new Subject();
  pensiunDoneListChannel = new Subject();
  employeeTypeChannel = new Subject();
  genderChannel = new Subject();
  employeeReligionChannel = new Subject();
  employeeMaritalChannel = new Subject();
  employeeBloodChannel = new Subject();
  yearServiceChannel = new Subject();
  educationChannel = new Subject();
  studyAssignmentChannel = new Subject();
  graduationClumpChannel = new Subject();
  awardChannel = new Subject();

  //DATA PRESENSI PEGAWAI
  presensiChartChannel = new Subject();
  presensiSummaryChannel = new Subject();
  presensiLateChannel = new Subject();
  presensiCutiChannel = new Subject();

  //DATA PUNISHMENT PEGAWAI
  punishmentChartChannel = new Subject();
  punishmentListChannel = new Subject();

  // echelonChannel = new Subject();
  //   employeeChannel = new Subject();

  // employeeStatistikChannel = new Subject();

  constructor() {
    this.dataChannel.next({ status: apiResponse.INITIAL });

    //FILTER
    this.workUnitChannel.next({ status: apiResponse.INITIAL });

    //DATA PEGAWAI
    this.employeesChannel.next({ status: apiResponse.INITIAL });
    this.agesChannel.next({ status: apiResponse.INITIAL });
    this.employeeStatusChannel.next({ status: apiResponse.INITIAL });
    this.jabatanChannel.next({ status: apiResponse.INITIAL });
    this.positionGradeChannel.next({ status: apiResponse.INITIAL });
    this.pensiunListChannel.next({ status: apiResponse.INITIAL });
    this.rankChannel.next({ status: apiResponse.INITIAL });
    this.pensiunDoneListChannel.next({ status: apiResponse.INITIAL });
    this.employeeTypeChannel.next({ status: apiResponse.INITIAL });
    this.genderChannel.next({ status: apiResponse.INITIAL });
    this.employeeReligionChannel.next({ status: apiResponse.INITIAL });
    this.employeeMaritalChannel.next({ status: apiResponse.INITIAL });
    this.employeeBloodChannel.next({ status: apiResponse.INITIAL });
    this.yearServiceChannel.next({ status: apiResponse.INITIAL });
    this.educationChannel.next({ status: apiResponse.INITIAL });
    this.studyAssignmentChannel.next({ status: apiResponse.INITIAL });
    this.graduationClumpChannel.next({ status: apiResponse.INITIAL });
    this.awardChannel.next({ status: apiResponse.INITIAL });

    //PRESENSI
    this.presensiChartChannel.next({ status: apiResponse.INITIAL });
    this.presensiSummaryChannel.next({ status: apiResponse.INITIAL });
    this.presensiLateChannel.next({ status: apiResponse.INITIAL });
    this.presensiCutiChannel.next({ status: apiResponse.INITIAL });

    //PUNISHMENT
    this.punishmentChartChannel.next({ status: apiResponse.INITIAL });
    this.punishmentListChannel.next({ status: apiResponse.INITIAL });

    // this.echelonChannel.next({ status: apiResponse.INITIAL })
    // this.employeeChannel.next({ status: apiResponse.INITIAL });

    // this.employeeStatistikChannel.next({ status: apiResponse.INITIAL })
    // this.exportGenderChannel.next({ status: apiResponse.INITIAL })
  }

  fetchData = async (query) => {
    try {
      this.dataChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchData(query)
        .then((result) => {
          this.dataChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.dataChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
      this.dataChannel.next({ status: apiResponse.ERROR, data: error });
    }
  };

  //FILTER
  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log('rxjs', 'Channel unsubscribed');
    }
  };

  //DATA PEGAWAI
  fetchEmployees = async (query) => {
    try {
      this.employeesChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployees(query)
        .then((result) => {
          this.employeesChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeesChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchAges = async (query) => {
    try {
      this.agesChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchAges(query)
        .then((result) => {
          this.agesChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.agesChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchEmployeeStatus = async (query) => {
    try {
      this.employeeStatusChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployeeStatus(query)
        .then((result) => {
          this.employeeStatusChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeStatusChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchJabatan = async (query) => {
    try {
      this.jabatanChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchJabatan(query)
        .then((result) => {
          this.jabatanChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.jabatanChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchPositionGrade = async (query) => {
    try {
      this.positionGradeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchPositionGrade(query)
        .then((result) => {
          this.positionGradeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.positionGradeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchPensiunList = async (query) => {
    try {
      this.pensiunListChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchPensiunList(query)
        .then((result) => {
          this.pensiunListChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.pensiunListChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchRank = async (query) => {
    try {
      this.rankChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRank(query)
        .then((result) => {
          this.rankChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rankChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchPensiunDoneList = async (query) => {
    try {
      this.pensiunDoneListChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchPensiunDoneList(query)
        .then((result) => {
          this.pensiunDoneListChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.pensiunDoneListChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchEmployeeType = async (query) => {
    try {
      this.employeeTypeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployeeType(query)
        .then((result) => {
          this.employeeTypeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeTypeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchGender = async (query) => {
    try {
      this.genderChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchGender(query)
        .then((result) => {
          this.genderChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.genderChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchReligion = async (query) => {
    try {
      this.employeeReligionChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchReligion(query)
        .then((result) => {
          this.employeeReligionChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeReligionChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchMarital = async (query) => {
    try {
      this.employeeMaritalChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchMarital(query)
        .then((result) => {
          this.employeeMaritalChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeMaritalChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchBlood = async (query) => {
    try {
      this.employeeBloodChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchBlood(query)
        .then((result) => {
          this.employeeBloodChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeBloodChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchYearService = async (query) => {
    try {
      this.yearServiceChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchYearService(query)
        .then((result) => {
          this.yearServiceChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.yearServiceChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchEducation = async (query) => {
    try {
      this.educationChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEducation(query)
        .then((result) => {
          this.educationChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.educationChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchStudyAssignment = async (query) => {
    try {
      this.studyAssignmentChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchStudyAssignment(query)
        .then((result) => {
          this.studyAssignmentChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.studyAssignmentChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchGraduationClump = async (query) => {
    try {
      this.graduationClumpChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchGraduationClump(query)
        .then((result) => {
          this.graduationClumpChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.graduationClumpChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  fetchAward = async (query) => {
    try {
      this.awardChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchAward(query)
        .then((result) => {
          this.awardChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.awardChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log('rxjs', 'Channel Unsubscribed');
    }
  };

  //DATA PRESENSI PEGAWAI
  fetchPresensiChart = async (query) => {
    try {
      this.presensiChartChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchPresensiChart(query)
        .then((result) => {
          this.presensiChartChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.presensiChartChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel unsubscribed');
    }
  };

  fetchPresensiSummary = async (query) => {
    try {
      this.presensiSummaryChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchPresensiSummary(query)
        .then((result) => {
          this.presensiSummaryChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.presensiSummaryChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel unsubscribed');
    }
  };

  fetchPresensiLate = async (query) => {
    try {
      this.presensiLateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchPresensiLate(query)
        .then((result) => {
          this.presensiLateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.presensiLateChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel unsubscribed');
    }
  };

  fetchPresensiCuti = async (query) => {
    try {
      this.presensiCutiChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchPresensiCuti(query)
        .then((result) => {
          this.presensiCutiChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.presensiCutiChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel unsubscribed');
    }
  };

  fetchPunishmentChart = async (query) => {
    try {
      this.punishmentChartChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchPunishmentChart(query)
        .then((result) => {
          this.punishmentChartChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.punishmentChartChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel unsubscribed');
    }
  };

  fetchPunishmentList = async (query) => {
    try {
      this.punishmentListChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchPunishmentList(query)
        .then((result) => {
          this.punishmentListChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.punishmentListChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log('rxjs', 'Channel unsubscribed');
    }
  };

  // fetchEmployeeStatistik = async (query) => {
  //     try {
  //         this.employeeStatistikChannel.next({ status: apiResponse.LOADING })
  //         await this.repository.fetchEmployeeStatistik(query).then((result) => {
  //             this.employeeStatistikChannel.next({ status: apiResponse.COMPLETED, data: result })
  //         }).catch((error) => {
  //             this.employeeStatistikChannel.next({ status: apiResponse.ERROR, data: error })
  //         })
  //     } catch (error) {
  //         console.log('rxjs', 'Channel Unsubscribed')
  //     }
  // }

  // fetchEchelon = async (query) => {
  //     try {
  //         this.echelonChannel.next({ status: apiResponse.LOADING })
  //         await this.repository.fetchEchelon(query).then((result) => {
  //             this.echelonChannel.next({ status: apiResponse.COMPLETED, data: result })
  //         }).catch((error) => {
  //             this.echelonChannel.next({ status: apiResponse.ERROR, data: error })
  //         })
  //     } catch (error) {
  //         console.log('rxjs', 'Channel Unsubscribed')
  //     }
  // }

  //   fetchEmployee = async (query) => {
  //     try {
  //       this.employeeChannel.next({ status: apiResponse.LOADING });
  //       await this.repository
  //         .fetchEmployee(query)
  //         .then((result) => {
  //           this.employeeChannel.next({
  //             status: apiResponse.COMPLETED,
  //             data: result,
  //           });
  //         })
  //         .catch((error) => {
  //           this.employeeChannel.next({ status: apiResponse.ERROR, data: error });
  //         });
  //     } catch (error) {
  //       console.log('rxjs', 'Channel Unsubscribed');
  //     }
  //   };
}

export default IndexBloc;
